module.exports = __webpack_public_path__ + "media/experience_pool.e6f2b4e4.mp4";